<script lang="ts" setup>
import { computed } from 'vue'
import './_index.scss'

import RoomieButton from '@lahaus-roomie/roomie/src/components/RoomieButton/index.vue'

import IconImage from '@lahaus-roomie/roomie/src/assets/icons/image-2.svg'
import IconVideo from '@lahaus-roomie/roomie/src/assets/icons/video-2.svg'
import IconMapPin from '@lahaus-roomie/roomie/src/assets/icons/map-pin-2.svg'

import type { Props } from './types'

const { t } = useI18n()

const props = defineProps<Props>()

const emit = defineEmits(['openGallery'])

const createCta = (
  id: string,
  icon: any,
  labelKey: string,
  galleryType: string,
  renderCondition: boolean,
  labelParams?: Record<string, any>
) => {
  return {
    id,
    icon,
    label: t(labelKey, labelParams),
    action: () => emit('openGallery', galleryType),
    renderCondition
  }
}

const ctas = computed(() => [
  createCta(
    'image',
    IconImage,
    'ctas.image',
    'pictures',
    props.listing.pictures_v2?.length > 0,
    { n: props.listing.pictures_v2?.length }
  ),
  createCta(
    'video',
    IconVideo,
    'ctas.video',
    'videos',
    props.listing.raw_listing?.attributes?.videos?.length > 0
  ),
  createCta(
    'location',
    IconMapPin,
    'ctas.location',
    'location',
    !!props.listing.raw_listing?.location?.latitude &&
      !!props.listing.raw_listing?.location?.longitude
  )
])

</script>

<script lang="ts">
export default {
  name: 'PdFeaturesSummary'
}
</script>

<template>
  <div class="pd-features-summary flex flex-row mt-24 px-24 lg:px-0">
    <div class="pd-features-summary-ctas flex flex-row justify-start items-center gap-x-8">
      <template
        v-for="cta in ctas"
        :key="`pdp-hero-button-open-${cta.id}-tab`">
        <RoomieButton
          v-if="cta.renderCondition"
          :id="`pdp-hero-button-open-${cta.id}-tab`"
          :data-lh-id="`pdp-hero-button-open-${cta.id}-tab`"
          :aria-label="cta.label"
          variant="secondary"
          class="pd-features-summary-button"
          size="md"
          @click="cta.action">
          <div class="flex flex-row gap-4 lg:gap-8 items-center">
            <component
              :is="cta.icon"
              class="pd-features-summary-icon w-24 h-24" />

            <p>
              {{ cta.label }}
            </p>
          </div>
        </RoomieButton>
      </template>
    </div>
  </div>
</template>

<i18n src="./i18n.json" lang="json" />
